import api from "../../api/axios";
import {
  CreatePackageData,
  Package,
  PackageInstall,
  UpdatePackageData,
} from "./types";

// Marketplace (Public)
export const getPackages = async (params: {
  q?: string;
  tags?: string;
  page?: number;
}): Promise<{ items: Package[]; total: number }> => {
  const itemsPerPage = 8;
  const page = params.page || 1;
  const skip = (page - 1) * itemsPerPage;
  const take = itemsPerPage;

  const apiParams: Record<string, string | number> = {
    skip,
    take,
  };

  if (params.q) {
    apiParams.search = params.q;
  }

  if (params.tags) {
    apiParams.tags = params.tags;
  }

  const response = await api.get("/packages", { params: apiParams });
  return response.data;
};

// Admin
export const createPackage = async (
  data: CreatePackageData
): Promise<Package> => {
  const formData = new FormData();
  formData.append("name", data.name);
  formData.append("description", data.description);
  formData.append("type", data.type);
  formData.append("is_publish", String(data.is_publish));

  if (data.tag_names && data.tag_names.length > 0) {
    formData.append("tags", JSON.stringify(data.tag_names));
  }

  if (data.icon) {
    formData.append("icon", data.icon);
  }

  if (data.package) {
    formData.append("package", data.package);
  }

  const response = await api.post("/packages", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  return response.data;
};

export const updatePackage = async (
  id: string,
  data: UpdatePackageData
): Promise<{
  message_code: number;
  data: {
    package_id: string;
  };
}> => {
  const formData = new FormData();

  if (data.name !== undefined) formData.append("name", data.name);
  if (data.description !== undefined)
    formData.append("description", data.description);
  if (data.type !== undefined) formData.append("type", data.type);
  if (data.is_publish !== undefined)
    formData.append("is_publish", data.is_publish);

  if (data.tag_names && data.tag_names.length > 0) {
    formData.append("tag_names", data.tag_names.join(","));
  }

  if (data.icon) {
    formData.append("icon", data.icon);
  }

  if (data.package) {
    formData.append("package", data.package);
  }

  const response = await api.put(`/packages/${id}`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  return response.data;
};

// Workspace
export const installPackage = async (
  packageId: string,
  agent_name?: string
): Promise<PackageInstall> => {
  const response = await api.post(`/packages/${packageId}/install`, {
    agent_name,
  });
  return response.data;
};

// Tags
export const getTags = async (): Promise<{ id: string; name: string }[]> => {
  const response = await api.get("/datasource/tags");
  return response.data;
};
